import request from '@/utils/request'
export const getHomeDataApi = (data) => {
    return request({
        url: 'Home/AdminHome',
        method: 'post',
        data
    })
}